import sessionDB from "../utils/sessionDB";

let cachedToken = null;
let cachedPayload = null;

function parseJwtPayload(token) {
  if (!token || typeof token !== "string") return null;

  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Defaults to the current session's access token (from sessionDB) rather
 * than a hardcoded value, so decoded claims always reflect whoever is
 * actually signed in.
 */
export function getJwtPayload(token = sessionDB.getAccessToken()) {
  if (!token) return null;
  if (token === cachedToken) return cachedPayload;

  cachedToken = token;
  cachedPayload = parseJwtPayload(token);
  return cachedPayload;
}

export function getJwtClaim(claim, token = sessionDB.getAccessToken()) {
  const payload = getJwtPayload(token);
  if (!payload || claim == null) return null;

  const value = payload[claim];
  if (value === null || value === undefined || value === "") return null;
  return value;
}

export function getEmployeeIdFromToken(token = sessionDB.getAccessToken()) {
  const payload = getJwtPayload(token);
  if (!payload) return null;

  const raw =
    payload.empId ??
    payload.employeeId ??
    payload.employee_id ??
    payload.emp_id;

  if (raw === null || raw === undefined || raw === "") return null;

  const empId = Number(raw);
  return Number.isFinite(empId) && empId > 0 ? empId : null;
}

export function getTenantIdFromToken(token = sessionDB.getAccessToken()) {
  const raw = getJwtClaim("tenantId", token) ?? getJwtClaim("tenant_id", token);
  if (raw === null || raw === undefined || raw === "") return null;

  const tenantId = Number(raw);
  return Number.isFinite(tenantId) && tenantId > 0 ? tenantId : null;
}

export function getUserEmailFromToken(token = sessionDB.getAccessToken()) {
  const payload = getJwtPayload(token);
  if (!payload) return null;

  const email = payload.email ?? payload.sub;
  if (!email || typeof email !== "string") return null;
  return email;
}
